import { network } from 'services/network';

import { QueryParams } from 'api/mutations/downloadExternalDocument.mutation';

export const downloadCardAssociatedDocument = async (params: QueryParams) => {
    const urlPath = `api/bo/downloadCardAssociatedDocument?docId=${params.documentId}`;

    const response = await network.post(urlPath, null, {
        transformRequest: [
            (data) => {
                return data;
            },
        ],
        responseType: 'blob',
    });

    const blob = new Blob([response.data], {
        type: response.headers['content-type'],
    });

    const url = window.URL.createObjectURL(blob);
    const w = window.open('', '_blank');
    if (w) {
        w.document.write(`
          <!doctype html><title>Image</title>
          <style>html,body{margin:0;background:#111;display:grid;place-items:center;height:100vh}</style>
          <img src="${url}" alt="" />
        `);
    }
};
